export default {
  name: 'Collapse',
  data: () => ({
    isOpen: false,
  }),
  props: {
    title: {
      type: String,
    },
    className: {
      type: String,
    },
    isInitialOpen: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.isInitialOpen) {
      this.isOpen = this.isInitialOpen;
    }
  },
  methods: {
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
};
